// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { TileSize, ListType, TileSizeMobile } from '../../_components/ui'

import { ModuleAdditionalRows } from '../../_contracts'
import { TeaserBoxVersion } from '../TeaserBox.contracts'
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
@Component({
  name: 'TeaserBoxInnerGrid6STextList'
})
export class TeaserBoxInnerGrid6STextList extends TeaserBoxAddonsMixin {
  public static readonly moduleVersion: TeaserBoxVersion = TeaserBoxVersion['6S-text-list']

  public gridConfig = {
    defaultSize: TileSize.S,
    mobileSize: TileSizeMobile.TILE_PLUS_TEXT,
    tiles: { 0: TileSize.S },
    listOffset: 6,
    listType: ListType.LIST
  }

  public get tilesOffset (): number {
    switch (this.teaserBoxConfig.additionalRows) {
      case ModuleAdditionalRows.addOne:
        return this.gridConfig.listOffset + 3
      case ModuleAdditionalRows.addTwo:
        return this.gridConfig.listOffset + 6
      default:
        return this.gridConfig.listOffset
    }
  }
}
